import usePermission from "@/hooks/usePermission";
import { ReactNode } from "react";
 interface MenuPermissionProps {
    menuId: string; // 所属菜单ID
    operation: string; // 操作类型（如 edit/delete）
    children: ReactNode; // 子组件（按钮）
  }
  
  const MenuPermissionControl = ({ menuId, operation, children }: MenuPermissionProps) => {
    const { hasMenuPermission } = usePermission();
    const hasPerm = hasMenuPermission(menuId, operation);
    return hasPerm ? <>{children}</> : null;
  };

  export default MenuPermissionControl;